import { render, staticRenderFns } from "./EmpresasList.vue?vue&type=template&id=8aa58282&"
import script from "./EmpresasList.vue?vue&type=script&lang=js&"
export * from "./EmpresasList.vue?vue&type=script&lang=js&"
import style0 from "./EmpresasList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports